import * as React from 'react';
import {CONST, getQueryStringParams, SearchInput, SearchSelect} from "../../common";

interface IState {
  form: {
    like: {
      search: string,
    },
    equal: {
      status: number;
      club_id: number;
      user_id: number;
      age_group_id: number;
      sport_id: number;
    }
  },
 }

export default class Filters extends React.Component<any, IState> {
  state: IState;

  UNSAFE_componentWillMount() {
    let old_data: any = getQueryStringParams("form");
    old_data = JSON.parse(old_data);
    this.setState({form:  {
        like: {
          search: old_data ? old_data.like.search : '',
        },
        equal: {
          status: old_data ? old_data.equal.status : '',
          club_id: old_data ? old_data.equal.club_id : '',
          user_id: old_data ? old_data.equal.user_id : '',
          age_group_id: old_data ? old_data.equal.age_group_id : '',
          sport_id: old_data ? old_data.equal.sport_id : '',
        }
      }})
  }

  handleInputForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name.split(".");
    let newAccess: any = Object.assign({}, this.state.form);
    newAccess[name[1]][name[2]] = e.target.value;
    this.setState({form: newAccess},() =>  this.props.getResults(this.state.form));
  }

  render(){
    const {clubs, coaches, ageGroups, sports} = this.props;
    return (
      <div className="row align-items-center">
        <SearchInput name={'form.like.search'} value={this.state.form.like.search} onChange={this.handleInputForm} placeholder={'Search Teams..'} />
        <SearchSelect name={'form.equal.club_id'} value={this.state.form.equal.club_id}  onChange={this.handleInputForm} options={clubs}/>
        <SearchSelect name={'form.equal.user_id'} value={this.state.form.equal.user_id}  onChange={this.handleInputForm} options={coaches}/>
        <SearchSelect name={'form.equal.age_group_id'} value={this.state.form.equal.age_group_id}  onChange={this.handleInputForm} options={ageGroups}/>
        <SearchSelect name={'form.equal.sport_id'} value={this.state.form.equal.sport_id}  onChange={this.handleInputForm} options={sports}/>
        <SearchSelect name={'form.equal.status'} value={this.state.form.equal.status}  onChange={this.handleInputForm} options={CONST.status}/>
      </div>
    )
  }
}